import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 提现订单列表接口
export const getAntWithdraw = (params: any) =>
  request({
    url: `manage/ant-withdraw`,
    method: 'get',
    params
  })

// 提现订单出金订单统计接口
export const getWithdrawStatistics = (params: any) =>
  request({
    url: `manage/ant-withdraw/statistics`,
    method: 'get',
    params
  })

// 提现订单修改状态接口
export const getWithdrawStatus = (params: any, data: any) =>
  request({
    url: `manage/ant-withdraw/status` + objToUrlParams(params),
    method: 'post',
    data
  })

// 提现订单修改状态接口
export const getWithdrawDetail = (params: any) =>
  request({
    url: `manage/ant-withdraw/${params}`,
    method: 'get'
  })

// 子订单列表接口
export const getChildDetail = (params: any) =>
  request({
    url: `manage/ant-withdraw/${params.ordernumber}/child`,
    method: 'get'
  })

// 修改单笔订单状态接口
export const changeCashStatus = (data: any) => request({
  url: `manage/ant-withdraw/${data.ordernumber}/status`,
  method: 'put',
  data: {
    ...data
  }
})

// 一键代付
export const oneClickPayfor = (data: any) =>
  request({
    url: 'manage/ant-withdraw/one-click-payfor',
    method: 'post',
    data
  })

// 付款钱包列表
export const getPayWalletList = (params: any) => request({
  url: `manage/pay-wallet`,
  method: 'get',
  params
})

// 创建付款钱包
export const addPayWallet = (data: any) => request({
  url: `manage/pay-wallet`,
  method: 'post',
  data
})

// 删除付款钱包
export const delPayWalletList = (params: any) => request({
  url: `manage/pay-wallet/${params.id}`,
  method: 'delete'
})

// 修改代付详情状态
export const setPaidStatus = (data: any) =>
  request({
    url: '/manage/ant-withdraw-order/' + data.ordernumber + '/change-status',
    method: 'put',
    data
  })
